export const api = {
  queryPersonList: '/vas/personnel/queryPersonListApi.json', //获取列表
  queryAccouts: '/cms/account/queryResultsByPag.json', // 按照条件查询账户信息

  querySecurityWorkGroup: '/cms/workgroup/querySecurityWorkGroup.json', //查询保卫工作组树
  addSecurityWorkGroup: '/cms/workgroup/addSecurityWorkGroup.json', //新增保卫工作组
  updateSecurityWorkGroup: '/cms/workgroup/updateSecurityWorkGroup.json', //修改保卫工作组
  deleteSecurityWorkGroup: '/cms/workgroup/deleteSecurityWorkGroup.json', //删除保卫工作组

  addSecurityInfo: '/cms/workgroup/addSecurityInfo.json', //新增当前保卫工作组保卫信息
  queryOutSecurityInfo: '/cms/workgroup/queryOutSecurityInfo.json',//查询不在当前保卫工作组保卫信息
  queryInSecurityInfo: 'cms/workgroup/queryInSecurityInfo.json',//查询在当前保卫工作组保卫信息
  getSecurityInfoList: '/cms/workgroup/querySecurityInfo.json',//查询保卫工作组及子节点保卫信息
  deleteSecurityInfo: '/cms/workgroup/deleteSecurityInfo.json',//删除保卫工作组保卫信息

  queryWorkShopList:'/cms/workshop/queryWorkShopList.json',// 查询车间列表
  addWorkShop:'/cms/workshop/addWorkShop.json', //新增车间
  updateWorkShop:'/cms/workshop/updateWorkShop.json',// 修改车间
  deleteWorkShop:'/cms/workshop/deleteWorkShop.json',//删除车间
  queryBuildingTree: '/cms/building/queryBuildingTree.json', //查询楼栋/楼层树

}